import VideoCardContent from 'components/shared/CardWithArrowLink/VideoCardContent'
import RelatedArticlesWithIntro from 'components/shared/RelatedArticlesWithIntro'
import SliceManager from 'components/shared/SliceManager'
import LargeVideo from 'components/slices/LargeVideo'
import delve from 'dlv'
import React from 'react'
import {
  fetchRelatedVideos,
  getDataDependencies,
  buildStaticPaths,
} from 'services/api'
import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'

import PreviewBanner from 'src/components/shared/PreviewBanner'
import fetchContentType from 'src/lib/Strapi/fetchContentType'
import { revalidating } from 'src/lib/staticProps'

const Videos = ({ pageData, preview }) => {
  const {
    slices,
    url,
    intro,
    gradientHeader,
    relatedVideos,
    relatedVideosIntro,
  } = pageData

  const slicedRelatedVideos = relatedVideos.slice(0, 3)

  return (
    <>
      {preview && <PreviewBanner />}
      <div className="container">
        {url && (
          <LargeVideo intro={intro} gradientHeader={gradientHeader} url={url} />
        )}
        {relatedVideos && relatedVideos.length > 0 && (
          <RelatedArticlesWithIntro
            intro={relatedVideosIntro}
            articles={slicedRelatedVideos}
            customCardComponent={VideoCardContent}
            customCardProps={{
              fullCardLink: true,
              featured: false,
            }}
          />
        )}
        {slices && <SliceManager slices={slices} />}
      </div>
    </>
  )
}

export async function getStaticPaths() {
  const data = await fetchAllSlugs('content-videos')
  return buildStaticPaths(data, 'content-videos')
}

export async function getStaticProps({ preview = null, params }) {
  const data = await fetchContentType(
    'content-videos',
    `filters[slug]=${params.slug}${
      preview ? '&publicationState=preview' : ''
    }`
  )
  const pageData = await getDataDependencies(delve(data, '0'))

  if (data?.length === 0 || !data) {
    return {
      props: {},
      notFound: true,
    }
  }

  const id = delve(pageData, 'id', null)
  const categories = delve(pageData, 'categories', { data: [] })
  const { videos } = await fetchRelatedVideos(id, categories)

  return revalidating({
    props: {
      pageData: {
        ...pageData,
        relatedVideos: videos,
        preview,
      },
    },
  })
}

export default Videos
